<template>
  <action-dialog
    ref="QrCodeOrderingDisabledDialog"
    :title="$t('order.qROrderingDisabled')"
    persistent
    :ok-label="$t('nav.actions.goToHome')"
    :cancel="false"
    @ok="$router.push({ path: '/' })"
  />
</template>

<script>
import { DELIVERY_TYPE_OPTIONS } from 'src/models/delivery-type/DeliveryType'
import ActionDialog from 'src/modules/consumer/components/ActionDialog'

export default {
  name: 'QrCodeOrderingDisabledDialog',
  components: {
    ActionDialog
  },
  models: {
    currentShowingByDeliveryLocationName: {
      movie: {
        fields: ['id', 'duration']
      },
      variables () {
        return {
          deliveryLocationName: this.$route.query['delivery-location'],
          skip: !this.$consumer || !this.$route.query['delivery-type'] || !this.$route.query['delivery-type'] === DELIVERY_TYPE_OPTIONS.THEATER_SEAT || !this.$route.query['delivery-location']
        }
      }
    }
  },
  mounted () {
    this.checkQRCodeOrderingEnabled()
  },
  methods: {
    async checkQRCodeOrderingEnabled () {
      if (!this.currentShowingByDeliveryLocationName.options.variables.skip) {
        await this.currentShowingByDeliveryLocationName.fetch(true)
        if (this.currentShowingByDeliveryLocationName.isRemote && this.currentShowingByDeliveryLocationName.isSeatDeliveryDisabled) {
          this.$refs.QrCodeOrderingDisabledDialog.show()
        }
      }
    }
  }
}
</script>
